import { Form, Switch } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';
import TextAreaWithActions from '../../../../../../components/Layout/TextAreaWithActions';

export const MarketingSettings = ({ form, brandName }) => {
  return (
    <SettingsContent title="MARKETING OPT-IN" icon={<FontAwesomeIcon icon={['far', 'envelope-open-text']} />}>
      <DescriptionBox
        className="w-100-P"
        title="Require Double Opt-In for Kiosk Signups"
        description="By enabling this setting, your clients will receive a message opt-in request after signing up via Kiosk Mode. This is required in some states, including California."
        input={
          <Form.Item name="doubleOptIn" valuePropName="checked">
            <Switch />
          </Form.Item>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Send Opt-In Message After Adding a New Client"
        description="This will automatically send an opt-in message to your clients after a sales associate adds them to Clientbook. This increases opt-in rates for marketing messages."
        input={
          <Form.Item name="delayOptIn" valuePropName="checked">
            <Switch />
          </Form.Item>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Opt-in Request Message"
        description={
          <div>
            <p>
              Below is the opt-in request message your clients will see. The opt-in request message should include help
              text with the following:
            </p>
            <p>“Successful opt-in requires the client to reply with ‘YES’"</p>
            <p>
              This should be made clear in the invitation. TCPA requires contacts be made aware that their consent is
              not a condition of making a purchase.{' '}
            </p>
            <p>Industry best practices include: </p>
            <ul>
              <li>describing your purpose or intent of auto-dialed messaging </li>
              <li>disclosing that message and data rates may apply.</li>
            </ul>
            <p>Maximum 500 Characters</p>
          </div>
        }
        input={
          <Form.Item
            name="optInInvite"
            rules={[
              {
                required: true,
                message: 'Please Enter an Opt-in Request Message',
                validator: (_, value) => {
                  if (value) {
                    if (value.replace('\n', '').length === 0) {
                      return Promise.reject(new Error('Please Enter an Opt-in Request Message'));
                    }
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Please Enter an Opt-in Request Message'));
                },
              },
            ]}
          >
            <div>
              <TextAreaWithActions
                containerStyleProps={{ border: '1px solid #d9d9d9', borderRadius: '6px' }}
                id="OptInRequestMessageInput"
                val={form.getFieldValue('optInInvite')}
                changeHandler={value => form.setFieldValue('optInInvite', value)}
                placeholder={`Hi :name:, It's :associate: from ${brandName} and you can reach me anytime at this number. Can I occasionally let you know about personalized promotions and products? If that's ok, reply YES to this msg`}
                hideImages
                template
                associate=":associate:"
                reviewMessage={form.getFieldValue('reviewMessage') || ' '}
              />
            </div>
          </Form.Item>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Mass Message Opt-In Request"
        description={
          <div>
            <p>
              Below is the opt-in request message your clients will see if they have been included in a mass message.
              The opt-in request message should include help text with the following:
            </p>
            <p>“Successful opt-in requires the client to reply with ‘YES’"</p>
            <p>
              This should be made clear in the invitation. TCPA requires contacts be made aware that their consent is
              not a condition of making a purchase.{' '}
            </p>
            <p>Industry best practices include: </p>
            <ul>
              <li>describing your purpose or intent of auto-dialed messaging </li>
              <li>disclosing that message and data rates may apply.</li>
            </ul>
            <p>Maximum 500 Characters</p>
          </div>
        }
        input={
          <Form.Item
            name="optInBulkInvite"
            rules={[
              {
                required: true,
                message: 'Please Enter an Opt-in (Mass Message) Request Message',
                validator: (_, value) => {
                  if (value) {
                    if (value.replace('\n', '').length === 0) {
                      return Promise.reject(new Error('Please Enter an Opt-in (Mass Message) Request Message'));
                    }
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Please Enter an Opt-in (Mass Message) Request Message'));
                },
              },
            ]}
          >
            <div>
              <TextAreaWithActions
                containerStyleProps={{ border: '1px solid #d9d9d9', borderRadius: '6px' }}
                id="OptInRequestMassMessageInput"
                val={form.getFieldValue('optInBulkInvite')}
                changeHandler={value => form.setFieldValue('optInBulkInvite', value)}
                placeholder={`Hi :name:, It's :associate: from ${brandName}. I have a message I'd like to send you but need your permission. I'll also occasionally let you know about personalized promotions and products? If that's ok, reply YES`}
                hideImages
                template
                associate=":associate:"
                reviewMessage={form.getFieldValue('reviewMessage') || ' '}
              />
            </div>
          </Form.Item>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Opt-in Confirmation Message"
        description={
          <div>
            <p>This is the message your clients will receive after they opt-in.</p>
            <p>
              The opt-in confirmation message should include instructions for opting out of future messages. For
              Example:{' '}
            </p>
            <p>“Thank you for signing up! You can opt out of future messages at any time by replying 'STOP' "</p>
            <p>Maximum 500 Characters</p>
          </div>
        }
        input={
          <Form.Item
            name="optInConfirm"
            rules={[
              {
                required: true,
                message: 'Please Enter an Opt-in Confirmation Message',
                validator: (_, value) => {
                  if (value) {
                    if (value.replace('\n', '').length === 0) {
                      return Promise.reject(new Error('Please Enter an Opt-in Confirmation Message'));
                    }
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Please Enter an Opt-in Confirmation Message'));
                },
              },
            ]}
          >
            <div>
              <TextAreaWithActions
                containerStyleProps={{ border: '1px solid #d9d9d9', borderRadius: '6px' }}
                id="OptInConfirmationInput"
                val={form.getFieldValue('optInConfirm')}
                changeHandler={value => form.setFieldValue('optInConfirm', value)}
                placeholder=":name:, thanks for agreeing to let us contact you! You are free to reply STOP if you don't want to hear from us anymore. freq varies, msg&data rates apply"
                hideImages
                template
                associate=":associate:"
                reviewMessage={form.getFieldValue('reviewMessage') || ' '}
              />
            </div>
          </Form.Item>
        }
      />
    </SettingsContent>
  );
};
